/**
 * Browser URL for a Person `image` value (CRM profile photo only).
 * - Legacy CRM: plain filename → `/images/<filename>`
 * - Absolute http(s) URLs → as-is (unless they are accreditation S3 refs)
 * - `ems:` / path keys that are accreditation photos are ignored (not profile)
 * - Other EMS upload keys still resolve via /api/ems/uploads for legacy cases
 */
import { resolveEmsUploadPublicUrl } from './emsPhotoUtils';

function isAccreditationPhotoRef(imageVal) {
  const s = String(imageVal || '')
    .trim()
    .replace(/\\/g, '/')
    .replace(/^ems:/i, '');
  if (!s) return false;
  if (/Accreditation\/2028/i.test(s)) return true;
  try {
    if (/^https?:\/\//i.test(s)) {
      return /Accreditation\/2028/i.test(decodeURIComponent(new URL(s).pathname || ''));
    }
  } catch {
    /* ignore */
  }
  return false;
}

export function resolvePersonImageUrl(imageVal, apiUrl) {
  if (imageVal == null || imageVal === '') return '';
  const raw = String(imageVal).trim();
  if (!raw) return '';

  // Accreditation badge photos must not render as CRM profile images.
  if (isAccreditationPhotoRef(raw)) return '';

  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return resolveEmsUploadPublicUrl(raw, apiUrl);
  }

  if (raw.startsWith('ems:')) {
    return resolveEmsUploadPublicUrl(raw.slice(4), apiUrl);
  }

  if (raw.includes('/') || raw.includes('\\')) {
    return resolveEmsUploadPublicUrl(raw, apiUrl);
  }

  return `/images/${raw}`;
}
